export default __webpack_public_path__ + "static/media/medicationAskAbout.5ee2db30.png";